// Recovered compiled webpack factory 92419. Edit this function expression; run npm run build.
(t, e, i) => {
  i.d(e, { KN: () => r, gQ: () => h, px: () => o, uj: () => s, vh: () => a, vw: () => l });
  let n = (t) => ({
      test: (e) => "string" == typeof e && e.endsWith(t) && 1 === e.split(" ").length,
      parse: parseFloat,
      transform: (e) => `${e}${t}`,
    }),
    s = n("deg"),
    r = n("%"),
    o = n("px"),
    a = n("vh"),
    l = n("vw"),
    h = { ...r, parse: (t) => r.parse(t) / 100, transform: (t) => r.transform(100 * t) };
}
